import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import color from "../common/styles/color";
import MEDIA from "../common/styles/media";

const LoginButton = ({ children }) => (
  <PurpleOutlineButton href="localhost:3000/login" title="login">
    {children}
  </PurpleOutlineButton>
);

LoginButton.propTypes = {
  children: PropTypes.node.isRequired
};

export default LoginButton;

const PurpleOutlineButton = styled.a`
  background: white; //linear-gradient(270deg, #47e4c1, #07cddd);
  color: ${color.grey};
  font-size: 20px;
  transition: all 0.2s ease;
  border-radius: 8px;
  min-width: 50px
  border: none;
  //box-shadow: 0 4px 20px 2px rgba(187, 187, 187, 0.5);
  font-family: inherit;
  font-weight: 700;
  padding: 10px 25px;
  display: inline-block;
  width: 80px;
  text-align: center;
  outline: none;
  cursor: pointer;
  letter-spacing: 0.5px;
  &:hover {
    background: linear-gradient(45deg, #F77DD6, #E5E57D);
    box-shadow: 0 2px 6px 1px rgba(187, 187, 187, 0.5);
    transform: scale(0.98);
  }
  svg {
    font-size: 85%;
    margin: 0px 2px 0px 4px;
    transition: all 0.3s ease;
  }
  ${MEDIA.MOBILE`
    font-size: 18px;
    padding: 10px;
  `};
`;
